/**
* @Author: Gang Jiang
* @Date: 2025-05-27 09:19:00
* @LastEditors: Gang Jiang
* @LastEditTime: 2025-05-27 09:19:00
* @Description: 代理子账号登录页面 包括Seller和Publisher
*/

<template>
  <div class="delegate-user-signin">
    <div class="left">
      <signInUpLeft />
    </div>
    <div class="right">
      <a-spin :spinning="loading">
        <div class="password">
          <h3>Welcome to ArtemisAds</h3>
          <p>Please setup your password</p>
          <div class="password-wrap">
            <a-form-item v-bind="validateInfos.password">
              <div class="password-input">
                <span class="password-title">Password</span>
                <artmisads-input-password v-model:visible="passwordVisible" @blur="() => validate('password')"
                  v-model:value="modelRef.password" />
              </div>
            </a-form-item>
          </div>
          <div class="password-wrap">
            <a-form-item v-bind="validateInfos.passwordConfirm">
              <div class="password-input">
                <span class="password-title">Confirm Password</span>
                <artmisads-input-password v-model:visible="passwordVisible" @blur="() => validate('passwordConfirm')"
                  v-model:value="modelRef.passwordConfirm" />
              </div>
            </a-form-item>
          </div>
          <a-form-item class="sign-btn-wrap">
            <artmisads-button class="sign-btn" type="primary" html-type="submit" @click="onSignIn">Sign
              In</artmisads-button>
          </a-form-item>
        </div>
      </a-spin>
    </div>
    <contextHolder />
  </div>
</template>

<script setup>
import jwt from 'jsonwebtoken'
import registerApi from '../../server/register'
import { useRoute, useRouter } from 'vue-router'
import { ref, reactive, onBeforeMount } from 'vue'
import { Form, notification } from 'ant-design-vue'
import { useUserInfoStore } from '~/storeData/index'
import signInUpLeft from '@/components/signInUpLeft.vue'

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const useForm = Form.useForm
const token = route.query.token
const store = useUserInfoStore()
const passwordVisible = ref(false)
const [api, contextHolder] = notification.useNotification()
const openNotification = (description) => {
  api.info({
    message: `Warning`,
    description: description,
    placement: 'topRight',
    duration: 10,
  })
}

const modelRef = reactive({
  password: '',
  passwordConfirm: '',
})
const rulesRef = reactive({
  password: [
    {
      required: true,
      validator: validatePassword,
      trigger: ['blur'],
    },
  ],
  passwordConfirm: [
    {
      required: true,
      validator: validatePasswordConfirm,
      trigger: ['blur'],
    },
  ],
})

const { validate, validateInfos, resetFields } = useForm(modelRef, rulesRef)

function validatePassword(_rule, value) {
  if (value === '') {
    return Promise.reject('Password cannot be empty')
  } else if (
    value.length < 8 ||
    !value.match(/[0-9]/) ||
    !value.match(/[A-Z]/)
  ) {
    return Promise.reject(
      'Password must be at least 8 characters with 1 upper case letter and 1 number'
    )
  } else {
    return Promise.resolve()
  }
}

function validatePasswordConfirm(_rule, value) {
  if (value === '') {
    return Promise.reject('Please input the password again')
  } else if (value !== modelRef.password) {
    return Promise.reject('Passwords do not match')
  } else {
    return Promise.resolve()
  }
}

function onSignIn() {
  validate().then(res => {
    if (!res.errorFields) {
      loading.value = true
      registerApi.acceptInvitation({
        token,
        password: modelRef.password,
        passwordConfirm: modelRef.passwordConfirm,
      }).then(res => {
        const { data, success, error } = res;

        loading.value = false

        if (success) {
          const menu = data.menu;
          const userToken = data.token;
          const userInfo = jwt.decode(userToken);

          store.setUserInfo(userInfo, userToken, menu);
          if (menu) {
            if (menu.children[0].children) {
              location.href = location.origin + menu.children[0].children[0].path;
            } else {
              location.href = location.origin + menu.children[0].path;
            }
          } else {
            location.href = location.origin + `/${userInfo.userType}/dashboard`;
          }
        } else {
          openNotification(error)
        }
      })
    }
  })
}

onBeforeMount(() => {
  if (!token?.length) {
    // 如果token不存在，则跳转到首页
    router.push('/')
  } else {
    // token存在，检查子账号是否是新用户
    registerApi.checkNewUser(token).then(res => {
      const { data, success, error } = res;
      if (success) {
        if (!data.isNewUser) {
          // 如果子账号不是新用户，则跳转到首页
          router.push('/sign-in')
        }
      } else {
        openNotification(error)
      }
    })
  }
})

</script>

<style lang="less" scoped>
@media screen and (min-width: 960px) {
  .delegate-user-signin {
    width: 100dvw;
    height: 100dvh;
    min-height: 700px;
    overflow: hidden;
    display: flex;
  }

  .right {
    display: flex;
    justify-content: center;
    // background: #F4F2FA;
    flex: 1;
    position: relative;
  }
}

@media screen and (max-width: 479px) {
  .delegate-user-signin {
    width: 100dvw;
    height: 100dvh;
    overflow: hidden;
    display: flex;
  }

  .right {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
}

.right {
  display: flex;
  align-items: self-start;
  justify-content: center;
}

.password {
  width: 480px;
  margin-top: 140px;
  border-radius: 16px;
  padding: 48px 40px 50px 40px;
  background: var(--color-white);
  box-shadow: var(--section-box-shadow-2);

  >p {
    margin-top: 8px;
    line-height: 20px;
    margin-bottom: 40px;
    color: var(--dark-3);
  }


  &-input {
    display: flex;
    flex-direction: column;

    .password-title {
      height: 16px;
      font-weight: 500;
      line-height: 16px;
      margin-bottom: 8px;
      color: var(--dark-2);
    }
  }

  .sign-btn {
    width: 100%;
    margin-top: 16px;

    &-wrap {
      margin-bottom: 0;
    }
  }
}
</style>